import * as React from 'react';
import { OS } from './App';
import { FormattedMessage } from 'react-intl';

interface StatusBarProps {
  lang: string;
  os: OS;
  id?: string;
  onLangChange: (lang: string) => void;
}

class StatusBar extends React.Component<StatusBarProps, {}> {

  render() {

    let styles = {
      host: {
        lineHeight: '30px',
        fontSize: '18px',
        display: 'flex',
        alignItems: 'center' as 'center'
      },
      list: {
        listStyle: 'none',
        display: 'flex',
        float: 'right',
        paddingRight: '1em'
      },
      link: {
        color: 'black',
        padding: '0 10px',
        textDecoration: 'none',
        display: 'flex'
      }
    };

    const appStore = this.props.os === OS.Android ? null : (
      <a href="https://itunes.apple.com/us/app/ontaxi-kharkov/id1098576462" target="_blank" style={styles.link}>
        <img src="/img/app-store.svg" style={{padding: '0 0.5em'}}/>
        <FormattedMessage id="Link.AppStore" />
      </a>
    );

    const googlePlay = this.props.os === OS.Ios ? null : (
      <a href="https://play.google.com/store/apps/details?id=ua.com.ontaxi.client" target="_blank" style={styles.link}>
        <img src="/img/google-play.svg" style={{padding: '0 0.5em'}}/>
        <FormattedMessage id="Link.GooglePlay" />
      </a>
    );

    return (
      <div id={this.props.id} style={styles.host}>
        <div style={{flex: '100%', display: 'flex'}}>
          {appStore}
          {googlePlay}
        </div>
        <ul style={styles.list}>
          <li
            style={{ color: this.getColor('en'), cursor: 'pointer', padding: '0 6px' }}
            onClick={() => this.props.onLangChange('en')}
          >
            En
          </li>
          <li
            style={{ color: this.getColor('ru'), cursor: 'pointer', padding: '0 6px' }}
            onClick={() => this.props.onLangChange('ru')}
          >
            Ru
          </li>
          <li
            style={{ color: this.getColor('uk'), cursor: 'pointer', padding: '0 6px' }}
            onClick={() => this.props.onLangChange('uk')}
          >
            Ua
          </li>
        </ul>
      </div>
    );
  }

  private getColor(lang: string): string {

    return this.props.lang === lang ? '#28B478' : 'black';
  }
}

export default StatusBar;



// WEBPACK FOOTER //
// /opt/build/sharedorder/node_modules/tslint-loader!./src/components/StatusBar.tsx